<template>
  <div>
    <modal
      name="info-modal"
      :adaptive="true"
      :reset="true"
      height="auto"
      :resizable="true"
      :scrollable="true"
      :focusTrap="true"
      draggable=".window-header"
    >
      <info title="Info" :text="responseText" @okClicked="closeInfo" />
    </modal>

    <p>Udaljena prijava</p>
    <!-- <button @click="testClick">cl</button> -->

    <p v-if="employee">{{ employee.firstName }} {{ employee.lastName }}</p>

    <!-- add new access log -->
    <div v-show="showManualLogAdd" style="margin-top: 40px">
      <add-log-manual
        v-if="employee"
        :employeeId="employee.employeeId"
        :isCustomDateSelectorVisible="false"
        :isButtonsVisible="true"
        :isRadioVisible="false"
        @accessRemoteCreated="responseCame"
      />
    </div>
  </div>
</template>

<script>
import reportService from "../../services/report.service";
import AddLogManual from "../parts/AddLogManual.vue";
import Info from "../parts/Info.vue";

export default {
  name: "RemoteAccess",

  components: {
    AddLogManual,
    Info,
  },

  data() {
    return {
      employee: null,
      showManualLogAdd: true,
      responseText: null,
    };
  },

  mounted() {
    // get my employee
    reportService.GetMyEmployee().then((response) => {
      this.employee = response.data;
    });
  },

  methods: {
    responseCame(response) {
      console.log("PAPAGAJ");
      let id = response.data;
      if (id != -1) {
        this.responseText = "Uspješno poslata prijava";
        this.$modal.show("info-modal");
      } else {
        this.responseText = "NEUSPJEH!";
        this.$modal.show("info-modal");
      }
    },

    closeInfo() {
      this.$modal.hide("info-modal");
    },

    testClick() {
      console.log("clicked!!");
      this.parallelCall();
    },

    async parallelCall() {
      console.log("papagaja");
      // let start_time = new Date().getTime();
      let promises = [];
      let result = [];

      const employeeIds = []; // this.$store.state.general.departmentData

      this.$store.state.general.departmentData.forEach((dep) => {
        if (dep.departmentId === 9) {
          dep.employee.forEach((e) => {
            employeeIds.push(e.employeeId);
          });
        }
      });

      // let currentEmployeeId = 5;

      // while (currentEmployeeId <= 6) {
      //   promises.push(this.fakeApiCall(currentEmployeeId));
      //   currentEmployeeId++;
      // }

      console.log(new Date());

      employeeIds.forEach((id) => {
        promises.push(this.fakeApiCall(id));
      });

      const data = await Promise.all(promises);
      data.forEach(({ data }) => {
        result = [...result, data];
      });

      console.log(new Date());
      console.log(result);
    },

    fakeApiCall(currentEmployeeId) {
      // return new Promise((resolve) => {
      //   setTimeout(() => {
      //     resolve({
      //       data: {
      //         currentEmployeeId,
      //         total: 100000,
      //       },
      //     });
      //   }, 1000);
      // });

      return reportService.GetNormalizedAccessDataByTimeRange(
        new Date("2022-06-18T00:00:00"),
        new Date("2022-06-19T00:00:00"),
        currentEmployeeId,
        null
      );
    },
  },
};
</script>
